import * as local from './local/orders';
import * as nodejs from './nodejs/orders';
import * as laravel from './laravel/orders';

import { API_DRIVER as DRIVER } from '../config/app';

const api = {
    local,
    nodejs,
    laravel
};

export const { list, get, create, update, pay, close, cancel, remove } = api[DRIVER];
